import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { useLogout } from '@/hooks/useLogout'

interface Props {
  /** 'light' (default) sur fond blanc, 'dark' sur fond navy. */
  variant?: 'light' | 'dark'
  className?: string
}

/**
 * Bouton "Se déconnecter" subtil en position fixe top-right.
 * À placer sur les pages d'onboarding / checkout / contact où l'utilisateur
 * authentifié pourrait vouloir quitter rapidement sans devoir revenir au dashboard.
 *
 * Utilise useLogout() pour une déconnexion complète (purge localStorage,
 * blacklist refresh token serveur, hard reload).
 */
export function LogoutCornerButton({ variant = 'light', className }: Props) {
  const { t } = useTranslation()
  const logout = useLogout()

  return (
    <button
      type="button"
      onClick={logout}
      className={cn(
        'fixed top-4 right-5 z-40 text-[13px] transition-colors',
        variant === 'dark'
          ? 'text-white/55 hover:text-white'
          : 'text-slate-500 hover:text-slate-900',
        className,
      )}
    >
      {t('common.logout', 'Se déconnecter')}
    </button>
  )
}
